export default __webpack_public_path__ + "static/media/sampleGraph.f1de65c3.svg";